module.exports = __webpack_public_path__ + "img/support_a13.2d1682de.png";